import http from './http'
var api={
    GetField(_name,_channel_id){
        return http.post('http://api.xincailiao.com/Open/GetField',{name:_name,channel_id:_channel_id});
    }
}
    

export default api